import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: 'Nunito', sans-serif;
    font-weight: normal;
    background-color: #001b5b;
  }
`

export default GlobalStyle
